import type { HistoricalEvent } from '../types'

export interface FilterCriteria {
  regionId?: string | null
  figureId?: string | null
  year?: number | null
  eraStartYear?: number | null
  eraEndYear?: number | null
  yearTolerance?: number  // when matching a single year, how many years counts as "at this moment"
}

function eventOverlapsYear(e: HistoricalEvent, year: number, tol: number): boolean {
  const start = e.year - tol
  const end = (e.yearEnd ?? e.year) + tol
  return year >= start && year <= end
}

function eventOverlapsRange(e: HistoricalEvent, rStart: number, rEnd: number): boolean {
  const eStart = e.year
  const eEnd = e.yearEnd ?? e.year
  return eStart <= rEnd && eEnd >= rStart
}

export function filterEvents(events: HistoricalEvent[], c: FilterCriteria): HistoricalEvent[] {
  const tol = c.yearTolerance ?? 30
  return events.filter(e => {
    if (c.regionId && !e.regionIds.includes(c.regionId)) return false
    if (c.figureId && !(e.figureIds ?? []).includes(c.figureId)) return false
    if (c.year !== null && c.year !== undefined) {
      if (!eventOverlapsYear(e, c.year, tol)) return false
    } else if (c.eraStartYear !== null && c.eraStartYear !== undefined && c.eraEndYear !== null && c.eraEndYear !== undefined) {
      if (!eventOverlapsRange(e, c.eraStartYear, c.eraEndYear)) return false
    }
    return true
  }).sort((a, b) => a.year - b.year)
}
